/**
 * Created by calhosh on 1/22/2025 test
 */
import {GET_AICHATBOT_INTEGRATION_PARAMETERS, SET_FORM_DETAILS, UPDATE_ACTIVE_FRAME, IS_DRAWER_COLLAPSED, GET_CURRENT_HEADER_AND_SECTION} from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export function setDrawerFormDetails(formdetails) {
	return {
		type: SET_FORM_DETAILS,
		response: formdetails
	};
}

export function isDrawerCollapsed(isCollapsed) {
	return {
		type: IS_DRAWER_COLLAPSED,
		response: isCollapsed
	};
}
export function updateActiveFrame(FrameKey) {
	return {
		type: UPDATE_ACTIVE_FRAME,
		response: FrameKey
	};
}

export function getCurrentHeaderAndSection(data) {
	return {
		type: GET_CURRENT_HEADER_AND_SECTION,
		response: data
	};
}
export function getAIChatBotIntegrationParameters(engagementId) {
	let url = env.getBaseURL(serviceURL, engagementId) + `IntegrationParameters`;

	return {
		type: GET_AICHATBOT_INTEGRATION_PARAMETERS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}
